<template>
    <div class="listIndContainer">
        <details @toggle="onToggle" class="custom-collapse">
            <summary class="collapse-summary">
                <span class="indTitle" :title="indicators.MainIndicatorName">{{ indicators.MainIndicatorName }}</span>
                <div v-if="showIndVal == true" class="indInfo">
                    <span>{{ indicators.RTACount }}</span>
                    <span>{{ indicators.RealValue == "-9999" || indicators.RealValue == "-9999,00" ? "-" :
                        indicators.RealValue }}</span>
                    <span>{{ indicators.PrevValue == "-9999" || indicators.PrevValue == "-9999,00" ? "-" :
                        indicators.PrevValue }}</span>
                </div>
                <slot class="btnSlot" name="button">Abrir/Fechar</slot>
            </summary>

            <div class="collapse-content">
                <section v-for="(op, opIdx) in indicators.OperationalInds" :key="'op-' + opIdx">
                    <span :class="showIndVal == true ? 'opTitle' : ''" :title="op.IndicatorName">{{ op.IndicatorName }}</span>
                    <div v-if="showIndVal == true" class="opIndInfos">
                        <span>{{ op.FCACount }}</span>
                        <span>{{ op.RealValue }}</span>
                        <span>{{ op.PrevValue }}</span>
                    </div>
                    <div>
                        <button class="detailsIndBtn" @click.prevent="handleDetails(op)">{{ innerBtnLabel }}</button>
                        <button v-if="showRemoveBtn" class="removeOpIndBtn" @click.prevent="removeIndicatorsFunc(op)">
                            <b-icon-trash-fill />
                        </button>
                    </div>
                </section>
            </div>
        </details>
    </div>
</template>

<script>
export default {
    name: "ManagementIndicator",
    props: ["indicators", "openDetailsFunc", "removeIndicatorsFunc", "mainIdx", "innerBtnLabel", "showRemoveBtn", "showIndVal"],
    data() {
        return {
            indOpDetails: {
                name: "",
                trigger: ""
            }
        }
    },
    methods: {
        onToggle(event) {
            this.$emit("toggle", event.target.open);
        },

        handleDetails(indicator) {
            this.openDetailsFunc(indicator)
        }
    },
};
</script>

<style scoped>
.custom-collapse {
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 1rem;
    overflow: hidden;
}

.collapse-summary {
    cursor: pointer;
    background-color: #F4F4F4;
    padding: 0.5rem 1rem;
    font-weight: bold;
    user-select: none;
    border-bottom: 1px solid #858585;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.collapse-summary::-webkit-details-marker {
    display: none;
}

.collapse-summary .indTitle {
    width: 30rem;
    max-width: 30rem;
    text-overflow: ellipsis;
    overflow: hidden;
}

.collapse-summary .indInfo {
    display: flex;
    align-items: center;
    column-gap: 5rem;
}

.collapse-summary .indInfo span {
    font-weight: normal;
}

.collapse-content {
    background-color: white;
}

.collapse-content section {
    padding: 0.5rem;
    border-bottom: 1px solid #858585;
    margin: 0 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.detailsIndBtn {
    background-color: #fff;
    border: 1px solid #008787;
    border-radius: 0.2rem;
    color: #008787;
    font-weight: 600;
    font-size: 0.8rem;
}

.detailsIndBtn:hover {
    background-color: #f8f8f8;
}

.removeOpIndBtn {
    border: 1px solid #FA394D;
    font-size: 0.8rem;
    border-radius: 0.2rem;
    background-color: #fff;
    color: #FA394D;
    margin-left: 0.8rem;
}

.opTitle {
    width: 17rem;
    max-width: 17rem;
    text-overflow: ellipsis;
    overflow: hidden;
}

.opIndInfos {
    display: flex;
    align-items: center;
    column-gap: 4.8rem;
}
</style>